import React, { useEffect, useState } from 'react';
import { ThunkDispatch } from "@reduxjs/toolkit";
import TalentDetailPanel from './components/TalentDetailPanel';
import avatar from '../../../assets/img/noAvatar.png';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from "react-redux";
import {
  fetchTalent, getOptionsRelatedTalent, setSelectedTalent, setCurrentPage,
  setSortBy, getStatistics, setFilterQuery, updateRecruitmentRankTalent,
  setActionStatus, setIsPanelDetailTalentOpen,
  getDetailTalent, setLoadingFetchTalent, clearSelectedTalent,
  setGenderOptions, setProfessionOptions, setCityOptions, setTypeOptions,
  setChangeJobOptions, setStatusOptions, setRecruitmentRankOptions,
  setTalentSearchForm, searchTalent, setDateOptions, setJobRecommendOptions,
  setJobViewRecommendOptions, setJobScoutRecommendOptions,
  setGlobalSearchTalentFormData, setGlobalTalentStatus, setIsClickSearch,
  getTalentTagOptions, setSearchTagResult, setHaveOtherConditionSearch,
  setCancelTalentStatus, setPreferredCityOptions, 
  setLoginTimeOptions,
  setViewJobTimeOptions,
  setExpectedConditionOptions,
  setWorkingStyleOptions,
  setResignationReasonOptions,
  searchNewsViewRecommend,
  setJobType1Options,
  setJobType2Options,
  setJobType3Options,
  setIndustry1Options,
  setIndustry2Options,
  setIndustry3Options,
  setTalentListPageSize,
  setSelectedRows,
  setDisplaySelectedCount,
  setTalentTagsSelected
} from "reducers/companyTalent";
import { getOptionsRelatedTalentRegister } from 'reducers/talentRegister';
import CompanyHeader from "components/CompanyHeader";
import CompanySideMenu from "components/CompanySideMenu";
import {formatDate, formatYear, formatName, getAgeByYearMonthDay, formatPadStartNumber, formatPercentageChange,
  dateToString, formatDateTime, trimStringFields
} from "utils/format";
import CustomToast from "components/CustomToast";
import {useSnackbar} from "notistack";
import {
  setChatSelected, setActionItems,
  setIsChatting,
  setIsScout,
  setJobSelected, setMessages,
  setTalentSelected,
  getDetailTalentChat, setIsNewChatFormOtherScreen,
  setMessageSendFrom, setGlobalFilterString, setIsOpenListJobPanel
} from "reducers/chatMessage";
import { setIsOpenSearchTagsPanel } from "reducers/talentTag";
import TextInput from '../../components/TextInput';
import CustomButton from '../../components/CustomButton';
import {LoadingIcon} from "components/Icons";
import {getIdFromObject, getListIdFromListObject, getRangeDateOfBirth, isEqualOnCommonFields, checkHasAdvanceFilledKeys} from "utils/util";
import Copyright from "../../components/Copyright";
import CustomDatePicker from '../../components/CustomDatePicker';
import TalentSearchFormDialog from './components/TalentSearchFormDialog';
import Dropdown from "../../components/Dropdown";
import CustomPagination from '../../components/CustomPagination';
import BulkScoutingDialog from './components/BulkScoutingDialog';
import { MESSAGE_SEND_FROM, MESSAGE_TYPE, BULK_MESSAGE_SESSION_MINUTE_EXTEND, TALENT_TYPE, STAFF_TYPE } from "../../constants/index";
import { bulkMessagesActions, extendSessionTimeOut } from "reducers/bulkMessages";
import i18n from 'i18next';
import { set } from 'lodash';
import dayjs from "dayjs";
import { options } from 'marked';

const initTableHeaders = [
    { title: "氏名<br />タレントID", isSortable: true, field: "last_name", currentSortState: 0, columnWidth: "11.375rem" },
    { title: "", isSortable: false, field: "", currentSortState: 0, columnWidth: "7.5rem" },
    { title: "種別", isSortable: true, field: "talent_type", currentSortState: 0, columnWidth: "7rem"  },
    { title: "転職意欲", isSortable: true, field: "change_job", currentSortState: 0, columnWidth: "6.125rem" },
    { title: "副業意欲", isSortable: true, field: "work_parttime", currentSortState: 0, columnWidth: "5.875rem" },
    { title: "選考状況", isSortable: true, field: "status", currentSortState: 0, columnWidth: "7.5rem" },
    { title: "アクセス<br />頻度", isSortable: true, field: "activity_level", currentSortState: 0, columnWidth: "5.75rem" },
    { title: "最終<br />アクセス日時", isSortable: true, field: "last_access", currentSortState: 1, columnWidth: "7.75rem" },
    { title: "採用<br />ランク", isSortable: true, field: "recruitment_rank", currentSortState: 0, columnWidth: "6.125rem" },
    { title: "職種", isSortable: true, field: "profession_1_name", currentSortState: 0, columnWidth: "7.25rem" },
    { title: "年齢", isSortable: true, field: "birthday", currentSortState: 0, columnWidth: "6.75rem" },
    { title: "性別", isSortable: true, field: "gender", currentSortState: 0, columnWidth: "6.75rem" },
    { title: "居住地", isSortable: true, field: "city", currentSortState: 0, columnWidth: "6.75rem" },
    { title: "登録日", isSortable: true, field: "created_at", currentSortState: 0, columnWidth: "auto" },
]

const sortingStates = ["default", "desc", "asc"];

const pageSizeOptions = [
    {
        id: 20,
        name: "20件を表示",
    },
    {
        id: 50,
        name: "50件を表示",
    },
    {
        id: 100,
        name: "100件を表示",
    },
    {
        id: 200,
        name: "200件を表示",
    },
];
// @ts-ignore
const RenderTableHeader = ({sortable, title, isSorting}) => {
    return <p className={`${isSorting ? 'font-bold underline underline-offset-4 alu-text-base-2' : 'font-normal alu-text-base-1'} ${sortable ? 'hover:cursor-pointer' : '' }  text-sm text-left`} dangerouslySetInnerHTML={{ __html: title }} />;
};

const TalentList = () => {
  const location = useLocation();
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const {staffInfo} = useSelector((state: any) => state.currentUser);
  const { talentList, currentPage, pageSize, talentCount, talentStatistics, isPanelDetailTalentOpen, sortBy,
    sortOrder, filterQuery, selectedTalent, talentOptionsRelatedData, actionStatus, selectedRows, displaySelectedCount,
    actionName, message, isSuccess, loadingFetchTalent, cancelTalentStatus,
    talentSearchForm, genderOptions, professionOptions, cityOptions, typeOptions,
    changeJobOptions, statusOptions, recruitmentRankOptions,
    scoutHistoryOptions, activityLevelOptions, loginTimeOptions, initSearchTalentForm,
    dateOptions, haveOtherConditionSearch, globalTalentStatus, globalTalentStatusDateRank,
    globalSearchTalentFormData, isClickSearch, talentTagOptions, searchTagResult, jobType1Options
  } = useSelector((state: any) => state.companyTalent);
  const { talentOptionsRelatedRegister } = useSelector((state: any) => state.talentRegister);
  const { isResetForm } = useSelector((state: any) => state.bulkMessages);
  const { isFromTagsList, isOpenSearchTagsPanel } = useSelector((state: any) => state.talentTag);

  const navigate = useNavigate();
  const [selected, setSelected] = useState({"name": "過去30日間", "id": 'day_30'});
  const [tableHeaders, setTableHeaders] = useState(initTableHeaders);
  const [talentTypes, setTalentTypes] = useState([]);
  const [talentStatus, setTalentStatus] = useState([]);
  const [searchFormOpen, setSearchFormOpen] = useState(false);
  const [formData, setFormData] = useState(initSearchTalentForm);
  const [formDataOrigin, setFormDataOrigin] = useState(initSearchTalentForm);
  const [searchTagQuery, setSearchTagQuery] = useState("");
  const [pageSizeOption, setPageSizeOption] = useState(pageSizeOptions.find((item: any) => item.id == pageSize));

  const [selectionPage, setSelectionPage] = useState<number | null>(null);
  const isFromDetail = location.state?.isFromDetail;

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const [bulkScoutingOpen, setBulkScoutingOpen] = useState(false);

  const handleChangeJobTypeLevel1 = (value) => {
      setFormData((prev: any) => ({
          ...prev,
          profession_1_id: value,
          profession_2_id: null,
          profession_3_id: null,
      }));

      // Reload options level 2
      if (value && value.code) {
          dispatch(setJobType2Options(talentOptionsRelatedRegister?.jobTypeOptions.filter(item => item.parent_id == value.code && item.level == 2)));
      } else {
          dispatch(setJobType2Options([]))
      }

      // Reload options level 3
      dispatch(setJobType3Options([]))
  }

  const handleSelectSort = (index: any) => {
    const newHeaders = tableHeaders.map((header, idx) => (index === idx)
    ? ({...header, currentSortState: (header.currentSortState + 1) % sortingStates.length})
    : ({...header, currentSortState: 0}));
    setTableHeaders(newHeaders);

    let newSortBy = "";
    for (let item of newHeaders) {
      if(item.currentSortState != 0 && item.field) {
        let refix_str = item.currentSortState == 1 ? "-" : "";
        newSortBy += refix_str + item.field;
        break
      }
    }
    dispatch(setSortBy(newSortBy));

    return newSortBy
  }

  const handleSort = (index: any) => {
    const newSortBy = handleSelectSort(index);
    handleSearchTalent(currentPage, newSortBy, null, null);
    // reset selected rows only when pagination exists
    dispatch(setSelectedRows([]));
    dispatch(setDisplaySelectedCount(0));
    setFormDataOrigin({
      ...formDataOrigin,
      sort_by: newSortBy
    });
  }

  const handleEnterInputSearch = () => {
    dispatch(setIsClickSearch(true));
    dispatch(setSelectedRows([]));
    dispatch(setDisplaySelectedCount(0));
    handleSearchTalent(1, null, null, pageSize);
  }

  const filterSelectedRowsWhenSearching = (talents) => {
    const talentIds = new Set(talents.filter((n: any) => n.is_active == true).map((n: any) => n.id));
    dispatch(setSelectedRows(selectedRows.filter(id => talentIds.has(id))));
    dispatch(setDisplaySelectedCount(selectedRows.filter(id => talentIds.has(id)).length));
  }

  const handleSelectRow = (id: number) => {
    let nextRows = [...selectedRows];

    // if selecting on a different page → reset previous selections
    if (selectionPage !== currentPage) {
      nextRows = [];
    }

    if (nextRows.includes(id)) {
      nextRows = nextRows.filter(i => i !== id);
    } else {
      nextRows.push(id);
    }

    dispatch(setSelectedRows(nextRows));
    dispatch(setDisplaySelectedCount(nextRows.length));
    setSelectionPage(currentPage);
  };

  const handleSelectAll = () => {
    const activeIds = talentList
      .filter((n: any) => n.is_active)
      .map((n: any) => n.id);

    let nextRows = [];

    if (selectionPage === currentPage && selectedRows.length === activeIds.length) {
      nextRows = [];
    } else {
      nextRows = activeIds;
    }

    dispatch(setSelectedRows(nextRows));
    dispatch(setDisplaySelectedCount(nextRows.length));
    setSelectionPage(currentPage);
  };

  useEffect(() => {
    dispatch(setIsPanelDetailTalentOpen(false));

    // Get options related talent
    dispatch(getOptionsRelatedTalent(null));
    dispatch(searchNewsViewRecommend({search: ""}));
    // Get options related talent
    dispatch(getOptionsRelatedTalentRegister(null));
    
    // Search, sort, filter, get list talents
    if (!globalTalentStatus?.id) {
      let page = 1
      if(currentPage && (isFromDetail || isFromDetail === undefined)) {
        page = currentPage
      }
      dispatch(setSelectedRows([]));
      dispatch(setDisplaySelectedCount(0));
      handleSearchTalent(page, sortBy, globalSearchTalentFormData, null);
    }
  }, []);

  useEffect(() => {
    dispatch(setJobType1Options(talentOptionsRelatedRegister?.jobTypeOptions.filter(item => item.parent_id == 0)));
    dispatch(setJobType2Options([]));
    dispatch(setJobType3Options([]));

    dispatch(setIndustry1Options(talentOptionsRelatedRegister?.industryOptions.filter(item => item.parent_id == 0)));
    dispatch(setIndustry2Options([]));
    dispatch(setIndustry3Options([]));
  }, [talentOptionsRelatedRegister]);

  useEffect(() => {
    if (searchTagResult && searchTagResult.status === 1) {
      dispatch(setSelectedRows([]));
      dispatch(setDisplaySelectedCount(0));
      handleSearchTalent(1, null, globalSearchTalentFormData, null);
      dispatch(setSearchTagResult(null));
    }
  }, [searchTagResult]);

  useEffect(() => {
    dispatch(getTalentTagOptions({searchQuery: searchTagQuery}));
  }, [searchTagQuery]);

  useEffect(() => {
    if(!sortBy) {
      return
    }
    
    let currentSortState = 2
    if(sortBy && sortBy.includes("-")) {
      currentSortState = 1
    }
    const newHeaders = tableHeaders.map((header, idx) => (sortBy.includes(header.field))
    ? ({...header, currentSortState: currentSortState})
    : ({...header, currentSortState: 0}));
    setTableHeaders(newHeaders);
  }, []);

  useEffect(() => {
    setFormData(talentSearchForm);
    setFormDataOrigin({
      ...talentSearchForm,
      sort_by: sortBy
    });
  }, [talentSearchForm]);

  useEffect(() => {
    if (isFromTagsList && isOpenSearchTagsPanel) {
      dispatch(setIsPanelDetailTalentOpen(true));
    } else if (isPanelDetailTalentOpen) {
      handleClose()
    }
  }, [location]);

  useEffect(() => {
    if (statusOptions?.length && globalTalentStatus?.id) {
      handleSelectTalentStatus();
    }
  }, [statusOptions, globalTalentStatus, globalTalentStatusDateRank]);

  const handleSelectTalentStatus = () => {
    if(!statusOptions || !statusOptions.length || !globalTalentStatus?.id) {
      return
    }
    let filterStatus = [] 
    for(const item of statusOptions) {
      if(item?.value?.includes(globalTalentStatus?.talent_filter_field) && !item?.value?.includes('not')) {
        filterStatus.push(item)
      }
    }
    const created_at = handleSelectCreatedAt(globalTalentStatus?.talent_filter_field, globalTalentStatusDateRank?.id)
    
    const filterScoutHistory = globalTalentStatus?.talent_filter_field === 'action_new_scout'
    ? scoutHistoryOptions.find(opt => opt.id === 'yes')
    : null;
    
    const data = {
      ...formData, 
      page: 1,
      sort_by: '-talent_last_access',
      status: filterStatus,
      status_date_rank: globalTalentStatusDateRank,
      created_at_start: created_at.created_at_start,
      created_at_end: created_at.created_at_end,
      scout_history: filterScoutHistory,
      type: globalTalentStatus?.type_of_talent,
      recruitment_rank: globalTalentStatus?.recruitment_rank,
      withdrawn_talent_included: globalTalentStatus?.withdrawn_talent_included,
    }
    setFormData({data});
    const pageNumber = 1;
    dispatch(setCurrentPage(pageNumber));
    dispatch(setSelectedRows([]));
    dispatch(setDisplaySelectedCount(0));
    handleSearchTalent(pageNumber, sortBy, data, null);
    dispatch(setGlobalTalentStatus({}));
    dispatch(setIsClickSearch(true));
  }

  const handleSelectCreatedAt = (talent_status: string, status_date_rank: string) => {
    if(!talent_status.includes('registration') || !status_date_rank) {
      return {"created_at_start": null, "created_at_end": null}
    }
    let action_query_time_start = null
    let date_now = dayjs();
    let action_query_time_end = date_now;

    if (status_date_rank === "month_0") {
      action_query_time_start = date_now.startOf("month");

    } else if (status_date_rank === "month_1") {
      action_query_time_start = date_now.subtract(1, "month").startOf("month");
      action_query_time_end = date_now.subtract(1, "month").endOf("month");

    } else if (status_date_rank === "day_30") {
      action_query_time_start = date_now.subtract(30, "day");
    } 
    else if (status_date_rank === "day_90") {
      action_query_time_start = date_now.subtract(90, "day");
    }
    else if (status_date_rank === "year_1") {
      action_query_time_start = date_now.subtract(1, "year");
    }

    if (!action_query_time_start || !action_query_time_end) {
      return {"created_at_start": null, "created_at_end": null}
    }
    return {"created_at_start": action_query_time_start, "created_at_end": action_query_time_end}
  }

  const renderTableHeaders = (header: any, index: any) => {
        switch(header.title) {
            case "氏名<br />タレントID":
                return (<th key={index} scope="col" className={`w-[${header.columnWidth}] pl-14 pr-1 py-2 text-left sticky left-[48px] z-20 bg-white`}>
                    <div className={`flex items-center`} onClick={() => header.isSortable && handleSort(index)}>
                        <RenderTableHeader sortable={header.isSortable} title={header.title} isSorting={header?.currentSortState !== 0} />
                        {header.isSortable && (<button className={`${header.currentSortState === 2 ? 'rotate-180' : 'rotate-0'}`}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" ><g clipPath="url(#clip0_8574_176)"><path d="M7 10L12 15L17 10H7Z" fill="#808080" /></g><defs><clipPath id="clip0_8574_176"><rect width="24" height="24" fill="white" /></clipPath></defs></svg></button>
                        )}
                    </div>
                </th>)
            case "":
                return (<th key={index} scope="col" className={`w-[${header.columnWidth}]
                      min-w-[${header.columnWidth}]
                      pl-2 pr-4 py-2 text-left
                      sticky left-[230px] z-30 bg-white
                      before:content-[''] before:absolute before:top-0 before:right-0 before:h-full before:w-[1px] before:bg-[#E0E0E0]`}>
                    <div className={`flex items-center`} onClick={() => header.isSortable && handleSort(index)}>
                        <RenderTableHeader sortable={header.isSortable} title={header.title} isSorting={header?.currentSortState !== 0} />
                        {header.isSortable && (<button className={`${header.currentSortState === 2 ? 'rotate-180' : 'rotate-0'}`}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><g clipPath="url(#clip0_8574_176)"><path d="M7 10L12 15L17 10H7Z" fill="#808080" /></g><defs><clipPath id="clip0_8574_176"><rect width="24" height="24" fill="white" /></clipPath></defs></svg></button>)}
                        </div>
                </th>)
            case "種別":
                return (<th key={index} className={`px-[0.375rem] pl-4 py-2 text-left w-[${header.columnWidth}] min-w-[${header.columnWidth}]`}>
                    <div className="flex items-center" onClick={() => header.isSortable && handleSort(index)}>
                        <RenderTableHeader sortable={header.isSortable} title={header.title} isSorting={header?.currentSortState !== 0} />
                        {header.isSortable && (<button className={`${header.currentSortState === 2 ? 'rotate-180' : 'rotate-0'}`}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <g clipPath="url(#clip0_8574_176)"><path d="M7 10L12 15L17 10H7Z" fill="#808080" /></g>
                            <defs><clipPath id="clip0_8574_176"><rect width="24" height="24" fill="white" /></clipPath></defs>
                            </svg></button>)}
                    </div>
                </th>)
            case "採用<br />ランク":
                return (<th key={index} className={`px-[0.375rem] py-2 text-left w-[${header.columnWidth}] min-w-[${header.columnWidth}]`}>
                    <div className="flex items-center" onClick={() => header.isSortable && handleSort(index)}>
                        <RenderTableHeader sortable={header.isSortable} title={header.title} isSorting={header?.currentSortState !== 0} />
                        {header.isSortable && (<button className={`${header.currentSortState === 2 ? 'rotate-180' : 'rotate-0'}`}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <g clipPath="url(#clip0_8574_176)"><path d="M7 10L12 15L17 10H7Z" fill="#808080" /></g>
                            <defs><clipPath id="clip0_8574_176"><rect width="24" height="24" fill="white" /></clipPath></defs>
                            </svg></button>)}
                    </div>
                </th>)
            default:
                return (<th key={index} className={`px-[0.375rem] py-2 text-left w-[${header.columnWidth}] min-w-[${header.columnWidth}]`}>
                    <div className="flex items-center" onClick={() => header.isSortable && handleSort(index)}>
                        <RenderTableHeader sortable={header.isSortable} title={header.title} isSorting={header?.currentSortState !== 0} />
                        {header.isSortable && (
                        <button className={`${header.currentSortState === 2 ? 'rotate-180' : 'rotate-0'}`}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <g clipPath="url(#clip0_8574_176)"><path d="M7 10L12 15L17 10H7Z" fill="#808080" /></g>
                            <defs><clipPath id="clip0_8574_176"><rect width="24" height="24" fill="white" /></clipPath></defs>
                            </svg></button>)}
                    </div></th>)
        }
    }

  const onPageChange = (pageNumber: any, pageSizeInput: any) => {
    dispatch(setCurrentPage(pageNumber));
    setFormDataOrigin({...formDataOrigin, page: pageNumber, sort_by: sortBy})
    handleSearchTalent(pageNumber, sortBy, formDataOrigin, null);
  };

  const isCurrentPageSelection = selectionPage === currentPage;

  let RecruitmentRankOptions = [ { name: 'A', id: 'a' }, { name: 'B', id: 'b' }, { name: 'C', id: 'c' } ]

  useEffect(() => {
      if (talentOptionsRelatedData.recruitment_ranks) {
        RecruitmentRankOptions = talentOptionsRelatedData.recruitment_ranks
        dispatch(setRecruitmentRankOptions(talentOptionsRelatedData.recruitment_ranks));
      }
      if (talentOptionsRelatedData.talent_types) {
        setTalentTypes(talentOptionsRelatedData.talent_types)
        dispatch(setTypeOptions(talentOptionsRelatedData.talent_types));
      }
      if (talentOptionsRelatedData.talent_status_options) {
        dispatch(setStatusOptions(talentOptionsRelatedData.talent_status_options));
        if(!isFromDetail) {
          handleSelectTalentStatus();
        }
      }
      if (talentOptionsRelatedData.date_options) {
        dispatch(setDateOptions(talentOptionsRelatedData.date_options));
      }
      if (talentOptionsRelatedData.gender_options) {
        dispatch(setGenderOptions(talentOptionsRelatedData.gender_options));
      }
      if (talentOptionsRelatedData.profession_options) {
        dispatch(setProfessionOptions(talentOptionsRelatedData.profession_options));
      }
      if (talentOptionsRelatedData.city_options) {
        dispatch(setCityOptions(talentOptionsRelatedData.city_options));
      }
      if (talentOptionsRelatedData.preferred_city_options) {
        dispatch(setPreferredCityOptions(talentOptionsRelatedData.preferred_city_options));
      }
      if (talentOptionsRelatedData.change_job_options) {
        dispatch(setChangeJobOptions(talentOptionsRelatedData.change_job_options));
      }
      if (talentOptionsRelatedData.job_recommend_options) {
        dispatch(setJobViewRecommendOptions(talentOptionsRelatedData.job_recommend_options));
        dispatch(setJobScoutRecommendOptions(talentOptionsRelatedData.job_recommend_options));
      }
      if (talentOptionsRelatedData.access_time_options) {
        dispatch(setLoginTimeOptions(talentOptionsRelatedData.access_time_options));
      }
      if (talentOptionsRelatedData.view_job_time_options) {
        dispatch(setViewJobTimeOptions(talentOptionsRelatedData.view_job_time_options));
      }
      if (talentOptionsRelatedData.expected_condition_options) {
        dispatch(setExpectedConditionOptions(talentOptionsRelatedData.expected_condition_options));
      }
      if (talentOptionsRelatedData.working_style_options) {
        dispatch(setWorkingStyleOptions(talentOptionsRelatedData.working_style_options));
      }
      if (talentOptionsRelatedData.reason_resignation_options) {
        dispatch(setResignationReasonOptions(talentOptionsRelatedData.reason_resignation_options));
      }
  }, [talentOptionsRelatedData]);

  useEffect(() => {
    if (actionStatus === 'fulfilled') {
      switch(actionName) {
          case 'updateTalentInfo':
            // Search, sort, filter, get list talents
            handleSearchTalent(null, sortBy, null, null)
            break;
          case 'cancelTalent':
            handleSearchTalent(null, sortBy, null, null)
            dispatch(getDetailTalent({ id: selectedTalent?.id }));
            break;
          default:
            break;
        }
    }
  }, [actionStatus, actionName]);

  useEffect(() => {
    if (cancelTalentStatus === 'fulfilled') {
      handleSearchTalent(null, sortBy, null, null)
      dispatch(setCancelTalentStatus("idle"));
    }
  }, [cancelTalentStatus]);

  const showToast = (title: any, mes: any, variant: any) => {
    enqueueSnackbar("I love snacks.", {
      content: (key) => (
        <CustomToast title={title} message={mes} variant={variant} snackbarKey={key} closeSnackbar={closeSnackbar} />
      ),
    });
  };

  // Close popup detail talent
  const handleClose = () => {
    dispatch(setIsPanelDetailTalentOpen(false));
    dispatch(clearSelectedTalent());
  };
  // Open popup detail talent
  const handleShowDetail = (item: any) => {
    if (selectedTalent?.id == item?.id && isPanelDetailTalentOpen) {
      return;
    }
    dispatch(setSelectedTalent({}));
    dispatch(setTalentTagsSelected([]));
    dispatch(getDetailTalent({ id: item?.id }));
    dispatch(setIsPanelDetailTalentOpen(true));
  };
  const setRecruitmentRank = (rank: any) => {
    for (let item of RecruitmentRankOptions) {
      if (item.id == rank) { return item.name; }
    }
    return null;
  };
  const getNameById = (id: any, items: any) => {
    if (!id) { return null; }
    for(let item of items) {
      if (item.id == id) { return item.name; }
    }
    return null;
  };
  const goToChat = (item: any) => {
    dispatch(setTalentSelected(item));
    dispatch(getDetailTalentChat({id: item?.talent_id}));
    dispatch(setIsChatting(true));
    dispatch(setIsNewChatFormOtherScreen(true));
    dispatch(setIsScout(false));
    dispatch(setChatSelected({}));
    dispatch(setJobSelected({}));
    dispatch(setMessages([]));
    dispatch(setActionItems([]));
    dispatch(setMessageSendFrom(MESSAGE_SEND_FROM.TALENT));
    dispatch(setGlobalFilterString(item?.talent_id));
    dispatch(setSelectedRows([])); 
    dispatch(setDisplaySelectedCount(0));
    navigate('/company/message')
  }

  const handleCloseOnEscKeyDown = (event:any) => {
    const activeElement = document.activeElement as HTMLElement | null;

    // Check if the active element is an input or textarea
    if (event.key === "Escape") {
      if (
        activeElement &&
        (activeElement.tagName === "INPUT" ||
          activeElement.tagName === "TEXTAREA")
      ) {
        activeElement.blur(); // Defocus the input field
        return; // Stop further execution
      } else {
        // If no input field is focused, close the panel
        dispatch(clearSelectedTalent());
        dispatch(setIsPanelDetailTalentOpen(false));
      }
    }
  };

  useEffect(() => {
    if (!isPanelDetailTalentOpen) {
      dispatch(clearSelectedTalent());
    }

    if (isPanelDetailTalentOpen) {
      window.addEventListener("keydown", handleCloseOnEscKeyDown);
    }

    return () => {
      window.removeEventListener("keydown", handleCloseOnEscKeyDown);
    };
  }, [isPanelDetailTalentOpen]);

  const checkHaveOtherConditionSearch = (data) => {
    if (checkHasAdvanceFilledKeys(data)) {
      dispatch(setHaveOtherConditionSearch(true));
    } else {
      dispatch(setHaveOtherConditionSearch(false));
    }
  }

  const handleSearchTalent = async (pageNumber, sort_by=sortBy, inputData, inputPageSize) => {
    let inputFormData = null
    let page = 1
    let pageSize = inputPageSize ? inputPageSize : pageSizeOption?.id

    if(inputData) {
      if(pageNumber) {
        page = pageNumber
      }
      inputFormData = {...inputData}
    } else {
      if(!pageNumber && !sort_by && globalSearchTalentFormData) {
        inputFormData = {...globalSearchTalentFormData}
        setFormData({...globalSearchTalentFormData})
        page = globalSearchTalentFormData.page
      } else {
        inputFormData = {...formData}
        page = pageNumber ? pageNumber : 1
      }
    }
    
    dispatch(setTalentSearchForm(inputFormData));
    let data = {
      ...inputFormData,
      page: page,
      page_size: pageSize,
      sort_by: sort_by,
      created_at_start: inputFormData.created_at_start ? dateToString(inputFormData.created_at_start) : null,
      created_at_end: inputFormData.created_at_end ? dateToString(inputFormData.created_at_end) : null,
      gender: getIdFromObject(inputFormData.gender),
      type: inputFormData?.type?.map(item => getIdFromObject(item)),
      work_parttime: getListIdFromListObject(inputFormData.work_parttime),
      change_job: getListIdFromListObject(inputFormData.change_job),
      status:  getListIdFromListObject(inputFormData.status),
      activity_level: getIdFromObject(inputFormData.activity_level),
      access_time: getIdFromObject(inputFormData.access_time),
      recruitment_rank: getIdFromObject(inputFormData.recruitment_rank),
      city: getListIdFromListObject(inputFormData.city),
      scout_history: getIdFromObject(inputFormData.scout_history),
      status_date_rank: getIdFromObject(inputFormData.status_date_rank),
      job_view_level: getIdFromObject(inputFormData.job_view_level),
      date_of_birth_start: inputFormData.date_of_birth_start ? dateToString(inputFormData.date_of_birth_start) : null,
      date_of_birth_end: inputFormData.date_of_birth_end ? dateToString(inputFormData.date_of_birth_end) : null,
      tags: getListIdFromListObject(inputFormData.tags),
      tag_condition: getIdFromObject(inputFormData.tag_condition),
      register_code: inputFormData.register_code,
      last_job_viewed_time: getIdFromObject(inputFormData.last_job_viewed_time),
      profession_1_id: getIdFromObject(inputFormData.profession_1_id),
      profession_2_id: getIdFromObject(inputFormData.profession_2_id),
      profession_3_id: getIdFromObject(inputFormData.profession_3_id),
      industry_1_id: getIdFromObject(inputFormData.industry_1_id),
      industry_2_id: getIdFromObject(inputFormData.industry_2_id),
      industry_3_id: getIdFromObject(inputFormData.industry_3_id),
      expected_condition: getListIdFromListObject(inputFormData.expected_condition, '|'),
      preferred_city_id: getListIdFromListObject(inputFormData.preferred_city_id),
      working_style_id: getListIdFromListObject(inputFormData.working_style_id),
      is_referred: inputFormData.is_referred ? true : null,
      reason_resignation: getListIdFromListObject(inputFormData.reason_resignation, '|'),
      withdrawn_talent_included: inputFormData.withdrawn_talent_included ? true : null,
    };
    data = trimStringFields(data);
    const retrievedTalents = await dispatch(searchTalent({ requestBody: data }));
    dispatch(setCurrentPage(page));
    checkHaveOtherConditionSearch(data);

    // Save search condition
    saveConditionSearch(page, sortBy, inputFormData)
  };

  const saveConditionSearch = (page, sortBy, inputFormData) => {
    const globalFormData = {
      ...globalSearchTalentFormData,
      ...inputFormData,
      page,
      page_size: pageSize,
      sort_by: sortBy,
    };
    dispatch(setGlobalSearchTalentFormData(globalFormData));
  };

  const advanceSearch = () => {
    dispatch(setTalentSearchForm(formData));
    setSearchFormOpen(true);
  };

  const handleBulkMessages = (chatType) => {
    filterSelectedRowsWhenSearching(talentList);

    dispatch(extendSessionTimeOut({min: BULK_MESSAGE_SESSION_MINUTE_EXTEND}));
    dispatch(setIsOpenListJobPanel(false))

    if (selectedRows.length == 0) {
      showToast("メッセージ", i18n.t('MSG_TALENT_CONDITION_BULK_MESSAGES'), "error");
      return;
    }
    dispatch(bulkMessagesActions.setBulkMessageDetail({}));
    dispatch(setJobSelected({}));
    dispatch(bulkMessagesActions.setIsResetForm(!isResetForm));

    const recipients = talentList.filter(item => selectedRows.includes(item.id)).map(item => item);
    dispatch(bulkMessagesActions.setRecipients(recipients));
    dispatch(bulkMessagesActions.setChatType(chatType));
    setBulkScoutingOpen(true);
  }

  const getMinCreatedAtDate = () => {
    if(formData.created_at_start) {
      return formData.created_at_start
    }
    return new Date(2000, new Date().getMonth(), new Date().getDate())
  };

  const getMaxCreatedAtDate = () => {
    if(formData.created_at_end) {
      return formData.created_at_end
    }
    return new Date(9999, new Date().getMonth(), new Date().getDate())
  };

  const handleSearchProcess = () => {
    dispatch(setSelectedRows([])); 
    dispatch(setDisplaySelectedCount(0));
    dispatch(setIsClickSearch(true));
    handleSearchTalent(1, sortBy, null, pageSize);
    dispatch(setCurrentPage(1));
    setFormDataOrigin({
      ...formData,
      sort_by: sortBy
    });
  }

  const handleChangeAge = (value, name) => {
    let age = value.replace(/\D/g, "");

    setFormData((prev) => ({
      ...prev,
      [name]: age,
    }));
    return;
  }

  const handleClearSearchForm = () => {
    setFormData(initSearchTalentForm);
    handleSearchTalent(1, sortBy, initSearchTalentForm, null);
    dispatch(setSelectedRows([]));
    dispatch(setDisplaySelectedCount(0));
    dispatch(setHaveOtherConditionSearch(false));
    dispatch(setIsClickSearch(false));
  }

  const handleSetPageSize = (option: any) => {
    dispatch(setSelectedRows([]));
    dispatch(setDisplaySelectedCount(0));
    dispatch(setCurrentPage(1));
    setPageSizeOption(option);
    dispatch(setTalentListPageSize(option.id));
    setFormDataOrigin({...formDataOrigin, page: 1, sort_by: sortBy, pageSize: option.id});
    handleSearchTalent(1, sortBy, formDataOrigin, option.id);
  }

  return (
    <>
      <CompanyHeader />
      <div className="mt-6 px-6 flex gap-6 relative">
          <CompanySideMenu />
        <div className="flex-1 flex flex-col">
          {/* Filter */}
          
          <div className='bg-white rounded-[0.9375rem] w-full alu-section-box-shadow px-6 py-4 pb-6 self-start'>
            <header className='flex gap-6 items-center mb-6'>
              <h3 className='text-xl font-bold alu-text-base-2'>タレント検索</h3>
              <CustomButton variant='outline' type="button" size="sm" onClick={advanceSearch}>詳細検索</CustomButton>
            </header>
            <div className='grid grid-rows-3 grid-cols-12 gap-x-8 gap-y-6'>
              <div className="col-span-2">
                <label className="block text-sm mb-2 alu-text-base-1">氏名・タレントID</label>
                {/* name, ID */}
                <TextInput
                  size="md"
                  name="name"
                  value={formData.name }
                  onChange={handleChange}
                  onKeyDown={(e: any) => e.key === "Enter" && handleEnterInputSearch()}
                  placeholder=""
                  maxLength={201}
                  clearIcon={true}
                  onClearQuery={() => {
                    setFormData((prev: any) => ({
                      ...prev,
                      name: '',
                    }));
                  }}
                  />
              </div>
              <div className="col-span-2">
                <label className="block text-sm mb-2 alu-text-base-1">タレント種別</label>
                {/* type */}
                <Dropdown
                  clearable={true}
                  inputWidth="full"
                  options={typeOptions}
                  placeholder=""
                  value={formData.type}
                  onChange={(value: any) => {
                    setFormData((prev) => ({ ...prev, type: value }))
                  }}
                  multiple={true}
                />
              </div>
              <div className="col-span-4">
                <label className="block text-sm mb-2 alu-text-base-1">登録日</label>
                {/* created_at */}
                <div className='flex items-center gap-2'>
                  <div className='flex-1'>
                    <CustomDatePicker
                      placeholderText=""
                      value={formData.created_at_start}
                      maxDate={getMaxCreatedAtDate()}
                      onChange={(value: any) => {
                        setFormData((prev) => ({
                          ...prev,
                          created_at_start: value,
                        }));
                      }}
                    />
                  </div>
                  <span className='shrink-0'>-</span>
                  <div className='flex-1'>
                    <CustomDatePicker
                      placeholderText=""
                      value={formData.created_at_end}
                      minDate={getMinCreatedAtDate()}
                      onChange={(value: any) => {
                        setFormData((prev) => ({
                          ...prev,
                          created_at_end: value,
                        }));
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="col-span-4 ">
                {/* tags */}
                <label className="block text-sm mb-2 alu-text-base-1">タグ</label>
                <div className="flex items-center gap-2">
                  <div className='flex-1'>
                    <Dropdown
                      clearable={true}
                      inputWidth="full"
                      options={talentTagOptions}
                      placeholder=""
                      value={formData.tags}
                      onChange={(value: any) => {
                        setFormData((prev) => ({ ...prev, tags: value }))
                      }}
                      multiple={true}
                      havingIcon={false}
                      searchInput={true}
                      searchQuery={searchTagQuery}
                      setSearchQuery={setSearchTagQuery}
                      noOptionsFoundText={searchTagQuery ? '指定した条件のタグは見つかりませんでした' : 'タグが登録されていません'}
                      optionStyles='px-2 py-[0.125rem] rounded-sm bg-[#F7F7F7] text-center'
                      actionsButton={[{ name: 'タグ管理', variant: 'outline', handleClick: () => {dispatch(setIsOpenSearchTagsPanel(false)); navigate('/company/talent/tags')}}]}
                    />
                  </div>
                  <div className='shrink-0 w-[152px]'>
                    <Dropdown
                      inputWidth="full"
                      options={[{name: 'すべて含む', id: 'and'}, {name: 'いずれかを含む', id: 'or'}, {name: 'すべて含まない', id: 'none_of'}]}
                      placeholder=""
                      value={formData.tag_condition}
                      onChange={(value: any) => {
                        setFormData((prev) => ({ ...prev, tag_condition: value }))
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="col-span-4">
                <label className="block text-sm mb-2 alu-text-base-1">選考状況</label>
                {/* status */}
                <div className='flex items-center gap-2'>
                  <div className='w-[calc(100%-160px)]'>
                    <Dropdown
                      clearable={true}
                      inputWidth="full"
                      options={statusOptions}
                      placeholder=""
                      value={formData.status}
                      onChange={(value: any) => {
                        setFormData((prev) => ({ ...prev, status: value }))
                      }}
                      optionStyles='min-w-[104px] px-2 py-[0.125rem] rounded-2xl bg-[#E0E0E0] text-center'
                      multiple={true}
                    />
                  </div>
                  <div className='shrink-0 w-[152px]'>
                    <Dropdown
                      clearable={true}
                      inputWidth="full"
                      options={dateOptions}
                      placeholder=""
                      value={formData.status_date_rank}
                      onChange={(value: any) => {
                        setFormData((prev) => ({ ...prev, status_date_rank: value }))
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="col-span-2">
                <label className="block text-sm mb-2 alu-text-base-1">転職意欲</label>
                {/* change_job */}
                <Dropdown
                  clearable={true}
                  inputWidth="full"
                  options={changeJobOptions}
                  placeholder=""
                  value={formData.change_job}
                  onChange={(value: any) => {
                    setFormData((prev) => ({ ...prev, change_job: value }))
                  }}
                  multiple={true}
                />
              </div>
              <div className="col-span-2">
                <label className="block text-sm mb-2 alu-text-base-1">アクセス頻度</label>
                {/* activity_level */}
                <Dropdown
                  clearable={true}
                  inputWidth="full"
                  options={activityLevelOptions}
                  placeholder=""
                  value={formData.activity_level}
                  onChange={(value: any) => {
                    setFormData((prev) => ({ ...prev, activity_level: value }))
                  }}
                />
              </div>
              <div className="col-span-2">
                <label className="block text-sm mb-2 alu-text-base-1">最終アクセス日時</label>
                {/* access_time */}
                <Dropdown
                  clearable={true}
                  inputWidth="full"
                  options={loginTimeOptions}
                  placeholder=""
                  value={formData.access_time}
                  onChange={(value: any) => {
                    setFormData((prev) => ({ ...prev, access_time: value }))
                  }}
                />
              </div>
              <div className="col-span-2">
                <label className="block text-sm mb-2 alu-text-base-1">採用ランク</label>
                {/* recruitment_rank */}
                <Dropdown
                  clearable={true}
                  inputWidth="full"
                  options={recruitmentRankOptions}
                  placeholder=""
                  value={formData.recruitment_rank}
                  onChange={(value: any) => {
                    setFormData((prev) => ({ ...prev, recruitment_rank: value }))
                  }}
                />
              </div>
              <div className="col-span-3">
                <label className="block text-sm mb-2 alu-text-base-1">経験した職種</label>
                {/* profession_1 */}
                <Dropdown
                  clearable={true}
                  inputWidth="full"
                  options={jobType1Options}
                  placeholder=""
                  value={formData.profession_1_id}
                  onChange={(value: any) => {handleChangeJobTypeLevel1(value)}}
                />
              </div>
              <div className="col-span-2">
                <label className="block text-sm mb-2 alu-text-base-1">年齢</label>
                {/* age_rank */}
                <div className='flex items-center gap-2'>
                  <div className='flex-1'>
                    <TextInput
                      clearIcon={true}
                      size="md"
                      type="text"
                      min={1}
                      max={100}
                      id="from_income"
                      name="from_income"
                      value={formData.age_from}
                      onChange={(e: any) => handleChangeAge(e.target.value, 'age_from')}
                      onClearQuery={() => handleChangeAge('', 'age_from')}
                      onKeyDown={(e: any) => e.key === "Enter" && handleEnterInputSearch()}
                      placeholder=""
                      maxLength={3}
                    />
                  </div>
                  <span>-</span>
                  <div className='flex-1'>
                    <TextInput
                      clearIcon={true}
                      size="md"
                      type="text"
                      min={1}
                      max={100}
                      id="from_income"
                      name="from_income"
                      value={formData.age_to}
                      onChange={(e: any) => handleChangeAge(e.target.value, 'age_to')}
                      onClearQuery={() => handleChangeAge('', 'age_to')}
                      onKeyDown={(e: any) => e.key === "Enter" && handleEnterInputSearch()}
                      placeholder=""
                      maxLength={3}
                    />
                  </div>
                  <p className='text-sm'>歳</p>
                </div>
              </div>
              <div className="col-span-2">
                <label className="block text-sm mb-2 alu-text-base-1">居住地</label>
                {/* city */}
                <Dropdown
                  clearable={true}
                  inputWidth="full"
                  options={cityOptions}
                  placeholder=""
                  value={formData.city}
                  onChange={(value: any) => {
                    setFormData((prev) => ({ ...prev, city: value }))
                  }}
                  multiple={true}
                />
              </div>
              <div className="col-span-2">
                <label className="block text-sm mb-2 alu-text-base-1">その他の条件</label>
                {/* city */}
                <div className='flex items-center h-9'>
                  <CustomButton variant='text' onClick={advanceSearch}>{haveOtherConditionSearch ? '指定あり…' : '指定する…'}</CustomButton>
                </div>
              </div>
              
              <div className="col-span-3 flex justify-end items-end gap-6">
                <CustomButton customStyle={"!w-[96px]"} variant='outline' type="button" size="md" onClick={handleClearSearchForm}>クリア</CustomButton>
                <CustomButton customStyle={"!w-[96px]"} type="button" size="md" onClick={handleSearchProcess}>検索</CustomButton>
              </div>
            </div>
          </div>

          {talentList.length > 0 && <div className='mt-6 flex items-center justify-between gap-6'>
            <div className='flex-1 flex items-center gap-4'>
              <div className='w-[10rem]'>
                <Dropdown
                  inputWidth="full"
                  options={pageSizeOptions}
                  placeholder=""
                  value={pageSizeOption}
                  onChange={handleSetPageSize}
                  customStyle='!font-bold'
                />
              </div>
              {!isClickSearch && talentList.length > 0 && <p className='text-sm alu-text-base-2'>全 <span className='font-bold text-base'>{talentCount}</span> 件</p>}
              {isClickSearch && talentList.length > 0 && <p className='text-sm alu-text-base-2'>
                {formData.register_code && (<>登録リンク {formData.register_code} に紐づいた <span className='font-bold text-base'>{ talentCount}</span> 件</>)}
                {!formData.register_code && <>検索結果 <span className='font-bold text-base'>{talentCount}</span> 件</>}
              </p>}
            </div>
            {talentCount > pageSize && (
                <CustomPagination
                  total={talentCount} currentPage={currentPage} pageSize={pageSize}
                  onPageChange={onPageChange}
                />
            )}
            <div className='flex-1'></div>
          </div>}

          {talentList.length > 0 ? 
          <> 
            <div className='bg-white rounded-t-lg w-full flex justify-between items-center px-4 py-2 mt-4'>
              <div className='flex gap-4 items-center'>
                {displaySelectedCount > 0 && <p className='text-sm alu-text-base-2'>{displaySelectedCount}件のタレントに</p>}
                <CustomButton
                  onClick={() => handleBulkMessages(MESSAGE_TYPE.SCOUT)}
                  type='button' size="sm" variant='outline'
                  disabled={!isCurrentPageSelection || !selectedRows || !selectedRows.length || staffInfo?.type == STAFF_TYPE.GENERAL}
                >
                  スカウトを送る
                </CustomButton>
                <CustomButton
                  onClick={() => handleBulkMessages(MESSAGE_TYPE.COMPANY_DISCUSS)}
                  type='button' size="sm" variant='outline'
                  disabled={!isCurrentPageSelection || !selectedRows || !selectedRows.length || staffInfo?.type == STAFF_TYPE.GENERAL}
                >
                  メッセージを送る
                </CustomButton>
                <div className='h-6 w-px bg-[#E0E0E0]'></div>
                <CustomButton onClick={() => {dispatch(setSelectedRows([])); dispatch(setDisplaySelectedCount(0)); navigate('/company/talent/bulk_list')}} type='button' size="md" variant='text'>
                  一括送信リスト
                </CustomButton>
              </div>
            </div>
            {/* table data */}
            <div className="rounded-b-lg relative custom-scrollbar overflow-x-auto" style={{width: `calc(100dvw - 10rem - ${24 * 3}px)`}}>
              <table className="table-auto border-collapse text-sm 3xl:min-w-full xl:min-w-[1680px] bg-white">
                <thead>
                  <tr className={`bg-white ${
                      selectedTalent?.id !== talentList[0]?.id ? "border-y" : "border-t"
                    } border-[#e0e0e0] top-0`}
                  >
                    <th scope="col" className="w-12 pl-[0.625rem] pr-2 py-2 text-left sticky left-0 z-20 bg-white">
                      <button onClick={handleSelectAll} disabled={staffInfo?.type == STAFF_TYPE.GENERAL || talentList.filter((n: any) => n.is_active == true).length == 0}>
                        {!isCurrentPageSelection || selectedRows.length == 0 || selectedRows.length !== talentList.filter((n: any) => n.is_active == true).length ? (
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <g clipPath="url(#clip0_8574_230)"><path d="M19 5V19H5V5H19ZM19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3Z" fill={!talentList.filter((n: any) => n.is_active == true).length > 0 || staffInfo?.type == STAFF_TYPE.GENERAL ? "#BBB" : "#808080"}/></g>
                            <defs><clipPath id="clip0_8574_230"><rect width="24" height="24" fill="white"/></clipPath></defs>
                          </svg>
                        ) : (
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <g clipPath="url(#clip0_8574_236)"><path d="M19 3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.11 21 21 20.1 21 19V5C21 3.9 20.11 3 19 3ZM10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z" fill="#FF861A"/></g>
                            <defs><clipPath id="clip0_8574_236"><rect width="24" height="24" fill="white"/></clipPath></defs>
                          </svg>
                        )}
                      </button>
                    </th>
                    {tableHeaders.map((header, idx) => renderTableHeaders(header, idx))}
                  </tr>
                </thead>
                <tbody>
                {talentList.map((item: any, idx: number) => {
                  return (
                    <tr key={idx}
                      className={`hover:cursor-pointer hover:bg-[#FFF3E5] border-l-none ${selectedTalent?.id === item?.id ? 'border !border-[#FF861A] border-double' : 'border-t border-t-[#E0E0E0]'} group`}
                      onClick={() => {handleShowDetail(item)}}
                    >
                      <td className="w-12 pl-[0.625rem] pr-2 py-2 text-left font-normal left-0 sticky z-20 bg-white group-hover:bg-[#FFF3E5]">
                        <button onClick={(e:any) => {handleSelectRow(item.id);e.stopPropagation()}} disabled={staffInfo?.type == STAFF_TYPE.GENERAL || !item.is_active}>
                          {!selectedRows.includes(item.id) ? (
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                              <g clipPath="url(#clip0_8574_230)"><path d="M19 5V19H5V5H19ZM19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3Z" fill={!item.is_active || staffInfo?.type == STAFF_TYPE.GENERAL ? "#BBB" : "#808080"}/></g>
                              <defs><clipPath id="clip0_8574_230"><rect width="24" height="24" fill="white"/></clipPath></defs>
                            </svg>
                          ) : (<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><g clipPath="url(#clip0_8574_236)"><path d="M19 3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.11 21 21 20.1 21 19V5C21 3.9 20.11 3 19 3ZM10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z" fill="#FF861A"/></g><defs><clipPath id="clip0_8574_236"><rect width="24" height="24" fill="white"/></clipPath></defs></svg>)}
                        </button>
                      </td>
                      <td className={`w-[11.375rem] px-1 py-2 alu-text-base-2 sticky left-[48px] z-20 bg-white group-hover:bg-[#FFF3E5] ${item?.is_active ? '' : 'before:absolute before:top-0 before:right-0 before:h-full before:w-[1px] before:bg-[#E0E0E0]'}`} colSpan={item?.is_active ? 1 : 2}>
                        <div className='flex items-center gap-3 relative z-20'>
                          <img src={item?.avatar ? item?.avatar : avatar} alt="Avatar"
                              className="w-10 h-10 rounded-full shrink-0"/>
                          <div>
                            <p className='text-sm alu-text-base-2 break-all'>
                              {formatName(item?.first_name, item?.last_name)}
                              {!item.is_active && "（退会済み）"}
                            </p>
                            <p className='text-xs alu-text-base-1'>{formatPadStartNumber(item?.talent_id, 6)}</p>
                          </div>
                          
                        </div>
                      </td>
                      {item.is_active && 
                        <td className="w-[7.5rem] pl-2 pr-4 py-2 alu-text-base-2 sticky left-[230px] z-30 bg-white group-hover:bg-[#FFF3E5]
                          before:content-[''] before:absolute before:top-0 before:right-0 before:h-full before:w-[1px] before:bg-[#E0E0E0]"
                          onMouseEnter={(e: any) => e.currentTarget.parentElement.classList.remove("hover:bg-[#FFF3E5]", "group")}
                          onMouseLeave={(e: any) => e.currentTarget.parentElement.classList.add("hover:bg-[#FFF3E5]", "group")}>
                          <div className="flex items-center px-2 py-2 relative z-20">
                            <CustomButton customStyle='!min-w-[80px]' size="sm" variant='outline' onClick={(e) => {e.stopPropagation(); goToChat(item)}}>メッセージ</CustomButton>
                          </div>
                        </td>
                      }
                      <td className="w-[7rem] pl-4 px-[0.375rem] py-2 alu-text-base-2">{item?.talent_type ? item?.talent_type : 'ー'}</td>
                      <td className="w-[6.125rem] px-[0.375rem] py-2 alu-text-base-2">{item?.change_job ? item?.change_job : 'ー'}</td>
                      <td className="w-[5.875rem] px-[0.375rem] py-2 alu-text-base-2">{item?.work_parttime ? item?.work_parttime : 'ー'}</td>
                      <td className="w-[7.5rem] px-[0.375rem] py-2 alu-text-base-2">
                        <span className="w-full rounded-2xl bg-[#e0e0e0] text-[#343a3d] text-sm px-2 py-0.5">{item.status}</span>
                      </td>
                      <td className="w-[5.75rem] px-[0.375rem] py-2 alu-text-base-2">{item?.activity_level}</td>
                      <td className="w-[7.75rem] px-[0.375rem] py-2 alu-text-base-2">{item?.last_access ? formatDateTime(item?.last_access) : 'ー'}</td>
                      <td className="w-[6.125rem] px-[0.375rem] py-2 alu-text-base-2">
                        {item?.recruitment_rank ? setRecruitmentRank(item?.recruitment_rank) : 'ー'}
                      </td>
                      <td className="w-[7.25rem] px-[0.375rem] py-2 alu-text-base-2">{item?.profession_1_name ? item?.profession_1_name : 'ー'}</td>
                      <td className="w-[6.75rem] px-[0.375rem] py-2 alu-text-base-2">
                        {getAgeByYearMonthDay(item?.birth_year, item?.birth_month, item?.birth_day)}</td>
                      <td className="w-[6.75rem] px-[0.375rem] py-2 alu-text-base-2">{item?.gender ? item?.gender : 'ー'}</td>
                      <td className="w-[6.75rem] px-[0.375rem] py-2 alu-text-base-2">{item?.city ? item?.city : 'ー'}</td>
                      <td className="w-auto px-[0.375rem] pr-4 py-2 alu-text-base-2">{item?.created_at ? formatDate(item?.created_at) : 'ー'}</td>
                    </tr>
                  );
                })}
                </tbody>
              </table>
            </div>
          </>
            : loadingFetchTalent ?
          (<div className="mt-6 flex items-center justify-center"><LoadingIcon/></div>)
            :  
          (
            <div className='mt-6 p-6 rounded-2xl w-full bg-white alu-section-box-shadow'>
              <p className='text-sm alu-text-base-2'>
                指定した条件のタレントは見つかりませんでした<br />
                条件を変更して再度検索してください
              </p>
            </div>
          ) 
        }

          {talentCount > pageSize && !loadingFetchTalent && (
            <div className="flex items-center justify-center mt-4"><CustomPagination
              total={talentCount} currentPage={currentPage} pageSize={pageSize}
              onPageChange={onPageChange}/>
            </div>)
          }
        </div>
        {isPanelDetailTalentOpen && (
          <div className="fixed right-2 top-2 bottom-2 z-[999]">
            <TalentDetailPanel onClose={handleClose} onScreen={MESSAGE_SEND_FROM.TALENT} />
          </div>
        )}
        {searchFormOpen && (
            <TalentSearchFormDialog open={searchFormOpen} onClose={() => {setSearchFormOpen(false);}} />
        )}
        {/* {bulkScoutingOpen && ( */}
            <BulkScoutingDialog open={bulkScoutingOpen} onClose={() => setBulkScoutingOpen(false)} />
        {/* )} */}
      </div>
      <Copyright view="company" />
    </>
  );
};

export default TalentList;
